const authServiceUrl = 'https://g-stage-go-api2.augmedix.com/auth/v1';
const providerServiceUrl = 'https://g-stage-go-api2.augmedix.com/provider/v1';
const appointmentServiceUrl = 'https://g-stage-go-api2.augmedix.com/appointment/v1';
const ehrServiceUrl = 'https://g-stage-go-api2.augmedix.com/ehr/v1';
const macrosServiceUrl = 'https://g-stage-go-api2.augmedix.com/macros/v1';
const transcriptServiceUrl = 'https://g-stage-go-ml-api2.augmedix.com/transcript/v1';
const gwpServiceUrl = 'https://g-stage-go-api2.augmedix.com/gwp/v1';
const signupServiceUrl = 'https://g-stage-go-api2.augmedix.com/signup/v1';
const graphqlApiUrl = 'https://g-stage-go-api2.augmedix.com/apollo-gateway/v1/graphql';
const nrtServerUrl = 'https://g-stage-go-nrt.augmedix.com';
const userManagementServiceUrl = 'https://g-stage-go-api2.augmedix.com/usermanagement/v1';
const ssoServiceUrl = 'https://g-stage-go-api2.augmedix.com/saml/v1';
const textExpanderServiceUrl = 'https://g-stage-go-api2.augmedix.com/textexpander/v1';

export const stageUrls = {
  authServiceUrl,
  providerServiceUrl,
  appointmentServiceUrl,
  macrosServiceUrl,
  ehrServiceUrl,
  transcriptServiceUrl,
  gwpServiceUrl,
  signupServiceUrl,
  graphqlApiUrl,
  nrtServerUrl,
  userManagementServiceUrl,
  ssoServiceUrl,
  textExpanderServiceUrl,
};
